/**
 * Helper: converte File em data URL (data:image/png;base64,...)
 */

import { INotificationFormValues } from "../schema/notifications.schema";

const NOTIFICATION_IMG_URL =
  "https://portal-cliente-backend-dev.s3.amazonaws.com/notifications/";

export const readFileAsDataUrl = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const buildErrorMessages = (formik) => {
  const errs = formik.errors as Partial<
    Record<keyof INotificationFormValues, string>
  >;
  const messages = Object.values(errs).filter(Boolean) as string[];
  // remove duplicadas, se houver
  return Array.from(new Set(messages));
};

export const buildNotificationImageUrl = (imageUrl: string): string => {
  return `${NOTIFICATION_IMG_URL}${imageUrl}`;
};
